import sanitize from 'sanitize-html';

/**
 * Removes the subdomain from a given host string.
 *
 * @param {string} host - The host string from which to remove the subdomain.
 * @returns {string} The host string without the subdomain. If the host does not have a subdomain, returns the original host.
 */
function removeSubdomain(host) {
    var parts = host.split('.');
    // If the host has more than two parts, it has a subdomain
    if (parts.length > 2) {
        return parts.slice(1).join('.');
    }
    return host;
}
/**
 * Removes port number from a hostname.
 *
 * @param {string} host - The hostname, potentially with port (e.g., 'example.com:3000')
 * @returns {string} The hostname without port (e.g., 'example.com')
 */
function removePort(host) {
    return host.replace(/:\d+$/, '');
}
/**
 * Sanitizes the input string by removing all HTML tags and attributes,
 * allowing only specified URL schemes.
 *
 * @param {string} input - The input string to be sanitized.
 * @returns {string} The sanitized string.
 */
function sanitizeInput(input) {
    return sanitize(input, {
        allowedTags: [],
        allowedAttributes: {},
        allowedSchemes: ['http', 'https'],
    });
}
/**
 * Resolves the host from the incoming HTTP headers.
 *
 * @param headers - The incoming HTTP headers.
 * @returns The resolved host as a string. If the host is an array, the first element is returned. If the host is not present, an empty string is returned.
 */
function resolveHost(headers) {
    return headers.host || '';
}
/**
 * Validates the given host string to ensure it is a valid hostname or IP address with an optional port number.
 *
 * @param {string} host - The host string to validate.
 * @throws Will throw an error if the host is empty or if the host format is invalid.
 */
function validateHost(host) {
    if (!host) {
        throw new Error('Host could not be determined');
    }
    // Regular expression to validate hostname or IP address with optional port number
    var hostPattern = /^(?!:\/\/)([a-zA-Z0-9-_]+(\.[a-zA-Z0-9-_]+)*)?(:\d+)?$/;
    if (!hostPattern.test(host)) {
        throw new Error('Invalid host format');
    }
}

export { removePort, removeSubdomain, resolveHost, sanitizeInput, validateHost };
